import { friendlyFormatIBAN, electronicFormatIBAN } from 'ibantools';
import { AccountType } from '@/features/dashboard/paymentConfig/types/AccountType.ts';

export const formatNRB = (input: string): string => {
  const digits = input.replace(/\D/g, '').slice(0, 26);
  const parts: string[] = [];
  if (digits.length > 0) parts.push(digits.slice(0, 2));
  for (let i = 2; i < digits.length; i += 4) {
    parts.push(digits.slice(i, i + 4));
  }
  return parts.join(' ');
};

export const formatIBANValue = (input: string): string => {
  return friendlyFormatIBAN(input) ?? input;
};

export const toElectronicFormat = (
  value: string,
  accountType: AccountType,
): string => {
  if (accountType === AccountType.NRB) {
    return value.replace(/\s/g, '');
  }
  return electronicFormatIBAN(value) ?? value.replace(/\s/g, '');
};

export const toDisplayFormat = (
  value: string,
  accountType: AccountType,
): string => {
  if (accountType === AccountType.NRB) {
    return formatNRB(value);
  }
  return friendlyFormatIBAN(value) ?? value;
};
